import type { CSSProperties } from '@mantine/core'
import type { OrderCardCompactProps } from './OrderCardCompact.types'
import { Box, Button, Text } from '@mantine/core'
import { clsx } from 'clsx'
import { extractRgbValues } from '@/shared/lib/mantine/mantine.utils'
import classes from './OrderCardCompact.module.css'

export function OrderCardCompact({
  order,
  onClick,
  onAction,
  actionText,
  className,
  animate,
  outline,
  color,
  statusColor,
  renderStatus,
  dataOnboarding,
}: OrderCardCompactProps) {
  const pulseStyle = (): CSSProperties | undefined => {
    const effectiveColor = color || statusColor

    if (!effectiveColor || (!animate && !outline))
      return

    const _pulseColorRGBA = `rgba(${extractRgbValues(effectiveColor)}, 0.7)`
    const _pulseColorRGBValues = extractRgbValues(effectiveColor, false)

    return {
      '--status-color': _pulseColorRGBA,
      '--pulse-color': _pulseColorRGBValues,
    } as CSSProperties
  }

  function handleCardClick() {
    if (onClick !== undefined) {
      onClick(order)
    }
  }

  function handleActionClick(e: React.MouseEvent) {
    e.stopPropagation()

    if (onAction !== undefined) {
      onAction()
    }
  }

  return (
    <div
      className={clsx({
        [classes.orderCardCompact]: true,
        [classes.cardOutline]: (animate || outline) && (color || statusColor),
        [classes.cardAnimationPulse]: animate && (color || statusColor),
        [className as string]: !!className,
      })}
      style={pulseStyle()}
      onClick={handleCardClick}
      role="button"
      tabIndex={0}
      data-onboarding={dataOnboarding}
    >
      <div className={classes.orderDetailsContainer}>
        <div className={classes.orderDetails}>
          <Box w="100%">
            <Text
              span
              className={classes.customerName}
              truncate="end"
            >
              {order.customerName}
            </Text>
            {renderStatus ? (
              renderStatus()
            ) : (
              <Text
                className={classes.statusTextWithIndicator}
                truncate="end"
              >
                {order.status}
              </Text>
            )}
          </Box>

        </div>
      </div>

      {actionText && onAction && (
        <Button
          color={color || statusColor || 'violet'}
          onClick={handleActionClick}
          variant="outline"
          w="100%"
          mt="auto"
        >
          {actionText}
        </Button>
      )}
    </div>
  )
}
